export const stepIndicatorMixin = {
    methods: {
          nextTransition(from, to) {
            return from > to ? "mid-previous" : "mid-next";
          },
    }

  };
  